import { addMinutes, startOfDay } from "date-fns";

import { formatTime } from "@/shared/lib";
import type { Option } from "@/shared/ui";

const MINUTES_PER_DAY = 24 * 60;
const DURATION_INTERVAL = 15;
const MIN_DURATION = 15;
const MAX_DURATION = 120;

export const getTimeSlotOptions = (date: Date) => {
  const startDate = startOfDay(date);
  const timeSlotOptions = [];

  for (let i = 0; i < MINUTES_PER_DAY; i += DURATION_INTERVAL) {
    const date = addMinutes(startDate, i);

    timeSlotOptions.push({ value: date, label: formatTime(date) });
  }

  return timeSlotOptions;
};

export const generateDurationIntervalOptions = () => {
  const intervals: Option<number>[] = [];

  for (
    let minutes = MIN_DURATION;
    minutes <= MAX_DURATION;
    minutes += DURATION_INTERVAL
  ) {
    intervals.push({
      value: minutes,
      label: `${minutes} minutes`,
    });
  }

  return intervals;
};
